import { render, staticRenderFns } from "./WidgetCsatReview.vue?vue&type=template&id=c54a686a&scoped=true&"
import script from "./WidgetCsatReview.vue?vue&type=script&lang=js&"
export * from "./WidgetCsatReview.vue?vue&type=script&lang=js&"
import style0 from "./WidgetCsatReview.vue?vue&type=style&index=0&id=c54a686a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54a686a",
  null
  
)

export default component.exports